import { IMenuItem } from './menu-item';
import { MENU ,MENU1,MENU2,MENU3,MENU4,MENU5,MENU6} from '../../../settings/dip-menu';
//import { MENU ,MENU1,MENU2,MENU3,MENU4,MENU5,MENU6} from '../../../settings/cs-menu';


export const MENUITEMS: IMenuItem[] = MENU;
export const MENUITEMS1: IMenuItem[] = MENU1;
export const MENUITEMS2: IMenuItem[] = MENU2;
export const MENUITEMS3: IMenuItem[] = MENU3;
export const MENUITEMS4: IMenuItem[] = MENU4;
export const MENUITEMS5: IMenuItem[] = MENU5;
export const MENUITEMS6: IMenuItem[] = MENU6;


// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/menu/mock-menu-items.ts